


































productIdRegEx = /gid:\/\/shopify\/Product\/(\d+)/
export default

	props:
		reviewId: String
		product: Object
		type:
			type: String
			default: 'badge'
			validator: (val) -> val in ['badge', 'reviews']

	mounted: ->
		# If no app key, then we're on a storefront without reviews
		return unless @storeId
		SDK_URL = "//staticw2.yotpo.com/#{@storeId}/widget.js"

		# Load the SDK if not already initialized
		unless window?.yotpo?.initialized then await @$loadScript SDK_URL
		# Refresh Yotpo's list of widgets so it updates any newly added widgets
		@refreshWidgets()

	watch:
		productId: (productId) ->
			return unless productId
			# Refresh Yotpo's list of widgets so it updates any newly added widgets
			@refreshWidgets()
	computed:
		isBadge: -> @type is 'badge'

		storeId: -> process.env.YOTPO_APP_KEY

		productId: ->
			if @reviewId
				return @reviewId
			else if @product?.grassdoorId
				return @product?.grassdoorId
			else
				return @product?.id?.match(productIdRegEx)?[1]

		title: -> @product?.title

		url: ->
			if @product?.type is "thc"
				return @product?.grassdoorLink
			else
				return @product?.onlineStoreUrl

		widgetType: -> switch @type
			when 'badge' then 'bottomLine'
			when 'reviews' then 'yotpo-main-widget'

		disclaimer: -> @$store.state.globals.productFields?.reviewsDisclaimer

	methods:
		refreshWidgets: ->
			@$nextTick ->
				window?.yotpo?.refreshWidgets()


